// Drag and drop item types
export const ItemTypes = {
  TODO_CARD: 'TODO_CARD',
} as const;

export type DragItem = {
  type: typeof ItemTypes.TODO_CARD;
  id: string;
  todo: import('./adhd-todo-manager').TodoItem;
};